import { useRouter } from "next/router";

const EmptyReviewList = () => {
  const { query } = useRouter();

  return query.voteScore || query.comment || query.type || query.haveMedia ? (
    <div
      className="h-[220px] rounded-lg bg-white  flex flex-col items-center justify-center md:mt-16"
      style={{
        boxShadow:
          "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)",
      }}>
      <i className="mrv mrv-building text-grey-200 text-[68px]"></i>
      {query.comment ? (
        <>
          <div className="mt-2 text-gray-500 text-fs-14">
            Không có kết quả phù hợp với từ khóa
          </div>
          <div className="text-center px-2">"{query.comment}"</div>
        </>
      ) : (
        <div className="mt-2 text-gray-500 text-fs-14">Không có kết quả</div>
      )}
    </div>
  ) : (
    <div className="flex-[1_1_auto] flex flex-col overflow-auto w-full gap-3 items-center mt-8 md:mt-16">
      <div className="text-fs-24 font-semibold text-grey-400">
        Chưa có bài review nào
      </div>
      <div className="text-grey-600 text-center">
        Hãy để lại <span className="text-grey-700 font-medium">Review</span>{" "}
        hoặc <span className="text-grey-700 font-medium">Câu hỏi</span> về dự án
        này để chúng ta cùng bàn luận.
      </div>
    </div>
  );
};

export default EmptyReviewList;
